import { Box, Stack, Typography } from "@mui/material";
import React from "react";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";

export const PageHeader = ({ headerText, rightContent, isChanged }) => {
  return (
    <Stack
      sx={{
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        py: "12px",
        px: "16px",
        height: "64px",
        bgcolor: isChanged ? "#000" : "#fff",
        position: "sticky",
        zIndex: 99,
        top: 0,
      }}
    >
      {typeof headerText === "string" ? (
        <Typography
          sx={{
            fontWeight: 600,
            fontSize: "24px",
            color: isChanged ? "#fff" : "#000",
          }}
        >
          {headerText}
        </Typography>
      ) : (
        headerText
      )}

      <Typography
        sx={{
          display: "flex",
          fontWeight: 400,
          fontSize: "14px",
          color: "#F8EFA4",
        }}
      >
        {!isChanged ? (
          " "
        ) : (
          <>
            <WarningAmberRoundedIcon sx={{ height: "18px", color: "" }} /> Some
            fields are changed, need to save
          </>
        )}
      </Typography>
      <Box>{rightContent}</Box>
    </Stack>
  );
};
